/* eslint-disable */
import {NavigationBlock} from './NavigationBlock';
/**
* @description Interface for Avensia.Commerce.Web.src.components.MainMenu.themes.BGH_RD3.mobile.customerPages.SiteModeNavigationBlock
*/
export interface SiteModeNavigationBlock extends NavigationBlock {
	
}
export const isSiteModeNavigationBlock = (model: unknown): model is SiteModeNavigationBlock => (model as SiteModeNavigationBlock).component === 'Bygghemma.Commerce.Web.src.components.MainMenu.themes.BGH_RD3.mobile.customerPages.SiteModeNavigationBlock';

